import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import tw from "twin.macro";
import {
  Subheading as SubheadingBase,
} from "../WhoWeAre/Headings.js";
import { SectionDescription } from "./Typography.js";
import { Container, ContentWithPaddingXl } from "./Layouts.js";
import { ReactComponent as ArrowRightIcon } from "../../Images/arrow-right-icon.svg";
import Cloudservices from "../../Images/Cloud-consulting-and-services.svg";
import CustomerIdentity from "../../Images/Customer-identity-management.svg";
import RealEstate from "../../Images/Real-estate-software-development.svg";
import Digital from "../../Images/Digital-transformation-services.svg";
import Framework from "../../Images/frameworks.svg";

// const Heading = tw(SectionHeading)``;
const Heading = tw.h2`text-4xl sm:text-5xl font-black tracking-wide text-center pt-16`;
const PdfHeading = tw.h2`text-4xl sm:text-5xl font-black tracking-wide text-center`;
const Subheading = tw(SubheadingBase)`text-center mb-3`;
const Description = tw(SectionDescription)`text-center mx-auto`;

const ThreeColumnContainer = styled.div`
  ${tw`flex flex-col items-center lg:items-stretch lg:flex-row flex-wrap lg:justify-center  mx-auto -mt-16 my-10`}
`;
const Column = styled.div`
  ${tw`lg:w-1/3 my-2`}
`;

// const Column = styled.div(props => [
//   props.columnPdf ? tw`lg:w-1/3 my-2 lg:my-0` : tw`lg:w-1/3 my-2`
// ])
const HighlightedText = tw.span`bg-primary-500 text-gray-100 px-4 inline-block`;

const Card = styled.a`
  ${tw`flex flex-col items-center text-center h-full mx-5 px-1  transition-transform duration-300 hover:cursor-pointer p-5 hover:shadow-xl hover:p-5 hover:bg-gray-100`}
  .imageContainer {
    ${tw`text-center rounded-full p-4 bg-gray-100 `}
    img {
      ${tw`w-8 h-8 hover:cursor-pointer`}
    }
  }

  /* .imageContainer1 {
    ${tw`text-center rounded-full  lg:p-0 p-4 bg-gray-100 `}
    img {
      ${tw`w-6 h-6 hover:cursor-pointer transform hover:scale-125`}
    }
  } */
  .title {
    ${tw`mt-4 text-xl font-medium leading-none md:whitespace-nowrap h-5`}
  }

  /* .title1 {
    ${tw`mt-1 text-xl font-medium leading-none h-5`}
  } */
  .description {
    ${tw`mt-4 text-lg text-gray-700 text-justify `}
  }
  .pdfdescription {
    ${tw`mt-4 text-lg text-gray-700 text-justify `}
  }

  .imageCss {
    ${tw`w-40! h-40!`}
  }
  .imageCss1 {
    ${tw`w-20! h-20!`}
  }

  .imageContainerCss {
    ${tw`p-2!`}/* .imageContainerCss1 {
${tw`p-0!`}
} */
  }

  .link {
    ${tw`mt-auto inline-flex items-center  justify-end w-full text-sm font-bold text-blue-700 leading-none hocus:text-primary-900 transition duration-300`}
    .icon {
      ${tw`ml-2 w-4`}
    }
  }
`;

//const DecoratorBlob = styled(SvgDecoratorBlob3)`
//  ${tw`pointer-events-none absolute right-0 bottom-0 w-64 opacity-25 transform translate-x-32 translate-y-40`}
//`;

const WhatWeDo = (props) => {
  const navigate = useNavigate();
  let solutions = [
      {
        route: "real-estate-software-company",
        imageSrc: RealEstate,
        title: "Real estate software development",
        description:
          "We bring our deep expertise of the U.S. real estate market to your advantage.",

        //url: "https://reddit.com"
      },
      ,
      {
        route: "cloud-services",
        imageSrc: Cloudservices,
        title: "Cloud consulting and services",
        description:
          "Increase resiliency and make your business global by benefiting from moving your systems to the cloud.",
        //url: "https://reddit.com"
      },
      {
        route: "customer-identity-and-access-management",
        imageSrc: CustomerIdentity,
        title: "Customer identity & access management",
        description:
          "CIAM streamlines customer authentication and authorization in apps, enhancing registration and login experiences.",
        //url: "https://timerse.com"
      },
      {
        route: "digital-transformation-services",
        imageSrc: Digital,
        title: "Digital transformation services ",
        description:
          "Leverage new technologies from maps, messaging and other online tools to enhance your business.",
        //url: "https://timerse.com"
      },
      {
        route: "application-framework",
        imageSrc: Framework,
        title: "Application-in-a-box",
        description:
          "Get off the ground running with your new enterprise app with our robust framework and repository.",
        //url: "https://timerse.com"
      },
    ],
    linkText = "Read More",
    heading = "",
    subheading = "",
    description = "",
    imageContainerCss = null,
    imageCss = null;

  return (
    <>
      <Container
        id={props.id}
        className={props.whatwedo === "pdf" ? "whatWeDoPdf" : ""}
      >
        <Heading>
          What
          <HighlightedText className="transform -skew-x-12 ml-3">
            We Do
          </HighlightedText>
        </Heading>
        <ContentWithPaddingXl>
          {subheading && <Subheading>{subheading}</Subheading>}
          {heading && <Heading>{heading}</Heading>}
          {description && <Description>{description}</Description>}
          <ThreeColumnContainer>
            {solutions.map((card, i) => (
              <Column key={i}>
                <Card
                  className="transform group hover:scale-110 group/item  hover:bg-slate-100"
                  onClick={() => navigate(`/what-we-do/${card.route}`)}
                >
                  <span
                    className="imageContainer imageContainerCss"
                    css={imageContainerCss}
                  >
                    <img
                      src={card.imageSrc}
                      alt=""
                      css={imageCss}
                      className={
                        props.whatwedo !== "pdf" ? "imageCss" : "imageCss1"
                      }
                    />
                  </span>
                  <span className="title" style={{ float: "left"}}>
                    {card.title}
                  </span>
                  <p className={ props.whatwedo !== "pdf" ? "description" : "pdfdescription"}>{card.description}</p>
                  {linkText && (
                    <>
                      <span className="link  group-hover:hidden">
                        <ArrowRightIcon className="icon rotate-45" />
                      </span>
                      <span className="link invisible group-hover:visible">
                        {linkText} <ArrowRightIcon className="icon " />
                      </span>
                    </>
                  )}
                </Card>
              </Column>
            ))}
          </ThreeColumnContainer>
        </ContentWithPaddingXl>
      </Container>
    </>
  );
};

export default WhatWeDo;